import { Capacitor } from '@capacitor/core';

/**
 * Native "app mode" — same codebase, different phone entry.
 *
 * - full (default — Dave approved): Framework as on web (login → steps → dashboard)
 * - lite: store-app style — login then dashboard (tracker / goals / to-do);
 *   Steps + e-learning can stay hidden in UI later; web desktop/mobile unchanged
 *
 * Default is full. Override only if product asks for lite:
 *   window.APP_CONFIG = { ..., nativeAppMode: 'lite' }
 */
export function getNativeAppMode() {
    if (typeof window === 'undefined') return 'full';
    if (window.nativeAppMode === 'lite' || window.nativeAppMode === 'full') {
        return window.nativeAppMode;
    }
    const fromConfig = window.APP_CONFIG && window.APP_CONFIG.nativeAppMode;
    if (fromConfig === 'lite' || fromConfig === 'full') return fromConfig;
    return 'full';
}

export function isNativeLiteAppMode() {
    return (
        Capacitor.isNativePlatform() && getNativeAppMode() === 'lite'
    );
}
